<template>
  <div>
    <b-modal size="md" no-close-on-backdrop hide-footer id="create" title="NOVO CENTRO DE CUSTO/LUCRO">
      <Create @success="paginate" />
    </b-modal>
    <div class="row">
      <div class="col-md-8 border">
        <div class="row">
          <div class="
              col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12
              pr-0
              d-flex
              align-items-center
            ">
            <h1 class="title-pages">CENTROS DE CUSTO/LUCRO</h1>
          </div>
          <div class="
              col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12
              pl-0
              text-right
              pl-0
            ">
            <v-btn v-if="permission('write', 'financial_profit_cost_center')" @click="$bvModal.show('create')"
              class="btn-add m-1"><i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR</v-btn>
          </div>
        </div>
        <div v-show="data.length > 0">
          <div class="row">
            <div class="col-md-12">
              <div class="input-group">
                <input type="text" class="form-control" placeholder="Pesquisar..."
                  @input="filter($event.target.value)" />
                <div class="
                    input-group-pprend
                    d-flex
                    align-items-center
                    justify-content-center
                  ">
                  <v-btn disabled><i class="fas fa-search" /></v-btn>
                </div>
              </div>
            </div>
            <div class="col-md-8"><span class="ml-2">Nome</span></div>
            <div class="col-md-2">Status</div>
            <div class="col-md-2">Ação</div>
          </div>
        </div>
        <b-overlay :show="loading" opacity="0.99">
          <div class="v-clean p-5 text-center" v-show="data.length == 0">
            <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
          </div>
          <div v-for="parent in filtered" :key="parent.id">
            <hr class="m-0" />
            <div class="row">
              <div class="col-md-8 d-flex align-items-center">
                <span class="ml-2">{{ parent.description }}</span>
              </div>
              <div class="col-md-2 d-flex align-items-center">
                <span>
                  <i :class="[
                    'fas fa-circle',
                    parent.status == 1 ? 'color-green' : 'color-warning',
                  ]"></i>
                  {{ parent.status == 1 ? "ATIVO" : "INATIVO" }}</span>
              </div>
              <div class="col-md-2 d-flex align-items-center">
                <b-modal size="md" no-close-on-backdrop hide-footer :id="`edit-${parent.id}`"
                  :title="`EDITAR CENTRO DE CUSTO/LUCRO: ${parent.description}`">
                  <Edit @success="paginate" :data="parent" />
                </b-modal>
                <v-btn v-if="permission('edit', 'financial_profit_cost_center')" x-small class="v-primary"
                  @click="edit(parent)">EDITAR</v-btn>
              </div>
            </div>
           
          </div>
        </b-overlay>
      </div>
      <div class="col-md-4">
        <h6>O que são centros de custo/lucro?</h6>
        <p class="worksansr">
          Centro de custo / lucro
          <b>é uma separação interna a uma empresa ou organização para rastrear
            despesas e receitas</b>. Essas unidades são usadas para associar custos e pagamentos
          arrecadados a projetos, departamentos ou filiais de uma empresa, por
          exemplo. Com suas despesas agrupadas por centro de custo é possível
          obter dados como: O centro de custo <b>"FILIAL X"</b> teve um custo
          total de <b>X</b> e um <b>lucro total</b> de <b>Y</b>. Ou ainda, O
          centro de custo <b>"OBRA Y"</b> teve um custo <b>X</b> com
          <b>energia elétrica</b>, um custo <b>Y</b> com <b>mão de obra</b>,
          etc.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Create from "./CostProfitCenter/Create";

import Edit from "./CostProfitCenter/Edit";

import api from "../../../services/api";

import permission from "../../../lib/permission";

export default {
  name: "CostProfitCenter",
  components: {
    Create,
    Edit,
  },
  data() {
    return {
      data: [],
      filtered: [],
      loading: false,
    };
  },
  created() {
    this.paginate();
  },
  methods: {
    permission,

    filter(text) {
      let { data } = this;

      let filtered = data.filter(
        ({ description }) =>
          String(description)
            .toLowerCase()
            .indexOf(String(text).toLowerCase()) > -1
      );

      this.filtered = filtered;
    },
    async paginate() {
      try {
        this.loading = true;

        const response = await api.get(
          "/rest-home/financial/configuration/profit-cost-center"
        );

        const { data } = response.data;

        this.data = data;
        this.filtered = data;

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    edit(parent) {
      this.$bvModal.show(`edit-${parent.id}`);
    },
  },
};
</script>

